export default __webpack_public_path__ + "static/blank-profile-picture-alt-e9e7fd1ca819f10ad976029d1f28f903.svg";